import { Navigate } from 'react-router-dom'
import { useAuthStore } from '../stores/authStore'

export default function ProtectedRoute({ path, children }) {
  const { user, canManageUsers } = useAuthStore()
  const ecommerceEnabled = !!user?.features?.ecommerce_enabled

  const pathToKey = {
    '/pages': 'pages',
    '/posts': 'posts',
    '/categories': 'categories',
    '/media': 'media',
    '/leads': 'leads',
    '/lead-log': 'leads',
    '/maintenance': 'maintenance',
    '/templates': 'templates',
    '/block-types': 'block-types',
    '/navigations': 'navigations',
    '/languages': 'languages',
    '/products': 'products',
    '/orders': 'orders',
    '/customers': 'customers',
    '/discounts': 'discounts',
    '/coupons': 'coupons',
    '/users': 'users',
    '/settings': 'settings',
  }

  const menuKey = pathToKey[path]
  const ecommerceKeys = new Set([
    'products',
    'orders',
    'customers',
    'discounts',
    'coupons',
  ])

  if (ecommerceKeys.has(menuKey) && !ecommerceEnabled) {
    return <Navigate to="/dashboard" replace />
  }

  if (menuKey === 'settings') {
    return children
  }

  if (menuKey === 'users') {
    if (!canManageUsers()) {
      return <Navigate to="/dashboard" replace />
    }
    return children
  }

  const menuPermissions = user?.menu_permissions || []

  if (menuPermissions.length > 0 && !menuPermissions.includes(menuKey)) {
    return <Navigate to="/dashboard" replace />
  }

  return children
}
